import { Paper, Grid } from "@material-ui/core"
import {
  InputOptionMaster,
  InputTextMaster,
  LabelRequired,
} from "App/Component/ui"
import { isNull } from "App/utils/helpers"
import {
  selectModeLokasi,
  selectOperationalStatus,
  selectStatusLokasi,
  selectTipeFisikLokasi,
} from "../helpers"
import { useSelectOption } from "App/hooks"
import { TYPE_INSTANCE1 } from "App/constants"
import { LIST_URL_REGISTRASI } from "utils/registrations"
import { LIST_URL_MASTER } from "utils/masters"

export default function LokasiInfo({ formDataInfo, setFormDataInfo }) {
  const handleChange = (text) => (e) => {
    setFormDataInfo({
      ...formDataInfo,
      [text]: e.target.value,
    })
  }

  const poliklinik = useSelectOption(
    false,
    "/policlinic/listpoliclinic",
    TYPE_INSTANCE1,
  )

  const dataJenisLokasi = [
    {
      value: "P",
      label: "Poliklinik",
    },
    {
      value: "L",
      label: "Layanan",
    },
  ]

  const layanan = useSelectOption(
    false,
    LIST_URL_MASTER.ruang_layanan.list,
    TYPE_INSTANCE1,
  )

  return (
    <>
      <Paper className="p-1 mb-1">
        <h4>INFO LOKASI</h4>

        <form onSubmit={(e) => console.log("No Method")}>
          <Grid container spacing={1}>
            <Grid item md={3}>
              <InputTextMaster
                name="kode"
                label={<LabelRequired label="Kode Ruangan" />}
                id="kode"
                placeholder="Kode Ruangan"
                value={formDataInfo.kode}
                onChange={handleChange("kode")}
              />
            </Grid>
            <Grid item md={3}>
              <InputTextMaster
                name="name"
                label={<LabelRequired label="Nama Ruangan" />}
                id="name"
                placeholder="Nama Ruangan"
                value={formDataInfo.name}
                onChange={handleChange("name")}
              />
            </Grid>
            <Grid item md={3}>
              <InputTextMaster
                name="description"
                label={<LabelRequired label="Deskripsi Ruangan" />}
                id="description"
                placeholder="Deskripsi Ruangan"
                value={formDataInfo.description}
                onChange={handleChange("description")}
              />
            </Grid>
            <Grid item md={3}>
              <InputTextMaster
                name="type"
                label={<LabelRequired label="Tipe Fungsi Lokasi" />}
                id="type"
                placeholder="Tipe Fungsi Lokasi"
                value={formDataInfo.type}
                onChange={handleChange("type")}
              />
            </Grid>
            <Grid item md={3}>
              <InputOptionMaster
                name="status"
                label={<LabelRequired label="Status Lokasi" />}
                id="status"
                withSearch={false}
                data={selectStatusLokasi}
                value={formDataInfo.status}
                needParse={false}
                onChange={handleChange("status")}
              />
            </Grid>
            <Grid item md={3}>
              <InputOptionMaster
                name="mode"
                label={<LabelRequired label="Mode Lokasi" />}
                id="mode"
                withSearch={false}
                data={selectModeLokasi}
                value={formDataInfo.mode}
                needParse={false}
                onChange={handleChange("mode")}
              />
            </Grid>
            <Grid item md={3}>
              <InputOptionMaster
                name="operationalStatus"
                label="Status Operasional"
                id="operationalStatus"
                withSearch={false}
                data={selectOperationalStatus}
                value={formDataInfo.operationalStatus}
                needParse={false}
                onChange={handleChange("operationalStatus")}
              />
            </Grid>
            <Grid item md={3}>
              <InputOptionMaster
                name="physicalType"
                label="Tipe Fisik Lokasi"
                id="physicalType"
                withSearch={true}
                data={selectTipeFisikLokasi}
                value={formDataInfo.physicalTypeValue}
                labelValue={formDataInfo.physicalTypeLabel}
                needParse={false}
                onChange={(e) => {
                  isNull(e)
                    ? setFormDataInfo({
                        ...formDataInfo,
                        physicalTypeValue: "",
                        physicalTypeLabel: "",
                      })
                    : setFormDataInfo({
                        ...formDataInfo,
                        physicalTypeValue: e.value,
                        physicalTypeLabel: e.label,
                      })
                }}
              />
            </Grid>
            <Grid item sm={3}>
              <InputOptionMaster
                name="jenisLokasi"
                label={<LabelRequired label="Jenis Lokasi" />}
                id="jenisLokasi"
                withSearch={true}
                value={formDataInfo.jenisLokasiValue}
                labelValue={formDataInfo.jenisLokasiLabel}
                needParse={false}
                onChange={(e) => {
                  isNull(e)
                    ? setFormDataInfo({
                        ...formDataInfo,
                        jenisLokasiValue: "",
                        jenisLokasiLabel: "Pilih Jenis Lokasi",
                        poliklinikValue: "",
                        poliklinikLabel: "Pilih Poliklinik",
                        layananValue: "",
                        layananLabel: "Pilih Layanan",
                      })
                    : setFormDataInfo({
                        ...formDataInfo,
                        jenisLokasiValue: e.value,
                        jenisLokasiLabel: e.label,
                        poliklinikValue: "",
                        poliklinikLabel: "Pilih Poliklinik",
                        layananValue: "",
                        layananLabel: "Pilih Layanan",
                      })
                }}
                data={dataJenisLokasi}
              />
            </Grid>
            {formDataInfo?.jenisLokasiValue === "P" && (
              <>
                <Grid item sm={3}>
                  <InputOptionMaster
                    name="poliklinik"
                    label={<LabelRequired label="Poliklinik" />}
                    id="poliklinik"
                    withSearch={true}
                    value={formDataInfo.poliklinikValue}
                    labelValue={formDataInfo.poliklinikLabel}
                    needParse={false}
                    onChange={(e) => {
                      isNull(e)
                        ? setFormDataInfo({
                            ...formDataInfo,
                            poliklinikValue: "",
                            poliklinikLabel: "Pilih Poliklinik",
                          })
                        : setFormDataInfo({
                            ...formDataInfo,
                            layananValue: "",
                            layananLabel: "Pilih Layanan",
                            poliklinikValue: e.value,
                            poliklinikLabel: e.label,
                          })
                    }}
                    data={poliklinik}
                  />
                </Grid>
              </>
            )}
            {formDataInfo.jenisLokasiValue === "L" && (
              <>
                <Grid item sm={3}>
                  <InputOptionMaster
                    name="layanan"
                    label={<LabelRequired label="Layanan" />}
                    id="layanan"
                    withSearch={true}
                    value={formDataInfo.layananValue}
                    labelValue={formDataInfo.layananLabel}
                    needParse={false}
                    onChange={(e) => {
                      isNull(e)
                        ? setFormDataInfo({
                            ...formDataInfo,
                            layananValue: "",
                            layananLabel: "Pilih Layanan",
                          })
                        : setFormDataInfo({
                            ...formDataInfo,
                            poliklinikValue: "",
                            poliklinikLabel: "Pilih Poliklinik",
                            layananValue: e.value,
                            layananLabel: e.label,
                          })
                    }}
                    data={layanan}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </form>
      </Paper>
    </>
  )
}
